// import moment, {Moment} from 'moment';
// we need to import from this to have access to business days

import {Moment, MomentInput} from 'moment';
import moment from './momentBusinessDays';

export interface getMinDateProps {
  today: MomentInput;
  dateValue: MomentInput;
  daysOffset?: number;
  isBusiness?: boolean;
  minutesOffset?: number;
}
/**
 * In the future we may want to add more types of offset (min, hours)
 * but for today, we just need to offset it by days
 * @param dateValue
 * @param daysOffset positive values only
 * @param isBusiness will only work if there's a daysOffset present
 * @returns Moment object
 */
export default function getMinDate({
  today,
  dateValue,
  isBusiness,
  daysOffset,
  minutesOffset,
}: getMinDateProps): Moment {
  const dateValueMoment = moment.utc(dateValue);
  const now = isBusiness
    ? moment.utc(today).businessAdd(daysOffset || 0)
    : moment
        .utc(today)
        .add(daysOffset || 0, 'days')
        .add(minutesOffset || 0, 'minutes');
  if (!dateValueMoment.isValid()) {
    return now;
  }
  return now.valueOf() >= dateValueMoment.valueOf() ? now : dateValueMoment;
}
